import dayjs from 'dayjs';
import {MRT_Row} from 'material-react-table';
import React from 'react';
import {Label, designSystemToken} from '@lightricks/react-design-system';
import {MONTH_SHORT_DAY_YEAR_FORMAT} from '@/config/timeFormats';
import {type CreatorBrandSafetyVetting} from '@/types/creatorBrandSafetyVetting';
import {PLACEHOLDER_ID} from '../constants';

function DateAddedCell({row}: {row: MRT_Row<CreatorBrandSafetyVetting>}) {
  const isPlaceholder = row.original.id === PLACEHOLDER_ID;
  const style = {
    color: isPlaceholder ? designSystemToken('semantic.fg.disabled') : null,
  };

  return (
    <Label size="sm" sx={style}>
      {dayjs(row.original.createdAt).format(MONTH_SHORT_DAY_YEAR_FORMAT)}
    </Label>
  );
}

export default DateAddedCell;
